import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { HelpSiteAccess } from "@shared/models/analytics/help-site"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "@shared/actions/create-narrative"
import createNarrative from "@shared/actions/create-narrative"

interface Payload {
  searchQuery: string | null
  articleTitle: string
  articleId: string
  ancestorIds: Array<string>
  parentId: string
}

export default function selectArticleFromSearchAction(payload: Payload): PreparedAction {
  return {
    name: "KB_SELECT_ARTICLE_FROM_SEARCH",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let newEvent: HelpSiteAccess = {
    ...createBlankEvent(),
    root_id: "help_site",
    root_type: "app",

    primary_verb: "view",

    primary_object_type: "help_article",
    primary_object_id: payload.articleId,
    primary_object_specifier: "search_box",
    primary_object_id_and_ancestor_ids: ["help_site", payload.articleId],
  }
  return createNarrative({
    title: "KB Article Selected from Search",
    description:
      "User accessed a help article through the suggested articles in their search of the KB",
    titleForAnalytics: "KB Search - Select Article",
    context: {
      searchQuery: payload.searchQuery,
      articleTitle: payload.articleTitle,
      articleId: payload.articleId,
      parentId: payload.parentId,
      ancestorIds: payload.ancestorIds,
    },
    newAnalyticsEvents: [newEvent],
  })
}
